import SupplierInterchangeCard from "./SupplierInterchangeCard";
import NoMatchingInvoicesFound from "../../NoMatchingInvoicesFound";
import { Box } from "@mui/material";
import InfoCardLoadingSkeleton from "../../skeleton/InfoCardLoadingSkeleton";
import { dialogTypes } from "../data";
import { withLoader } from "../../hocs/withLoader";
import { styles } from "../styles";
import { InventoryActivityReportViewVO } from '../../../types/model/valueObject/InventoryActivityReportViewVO';

interface MapProps {
    interchanges?: InventoryActivityReportViewVO[] | undefined;
    openDialog: (type: keyof typeof dialogTypes, item: InventoryActivityReportViewVO) => void;
    account: any;
    isLoading: boolean;
}
const SupplierInterchangeMap = (props: MapProps) => {
    const {interchanges, openDialog, account, isLoading} = props;

    return <Box component={'div'} mt={4} sx={{
                ...(!interchanges?.length && !isLoading) && styles.container,
                '& thead th': {
                    fontWeight: 600
                },
    
            }}> 
                { interchanges?.length ? interchanges.map((item:any) => <SupplierInterchangeCard key={item.id} interchange={item} openDialog={openDialog} account={account}/>) : <NoMatchingInvoicesFound message="No matching interchanges found"/>}
                
    </Box>
}
export default withLoader(SupplierInterchangeMap, InfoCardLoadingSkeleton);